var exports = {
  "Ve": "dateLink__IC75fj",
  "sR": "RelativeTime__isT-DQ",
  "Ur": "authorLabel__HB0xNL",
  "M1": "IssueBodyHeaderContainer__FFEvZk",
  "kS": "IssueBodyHeaderContainer_inlineAvatars__jtIrNF",
  "NX": "viewerDidAuthor___HAN1A",
  "Gd": "viewerDidNotAuthor__ZuIsgG",
  "g$": "activityHeaderWrapper__lI1Kau",
  "H": "avatarContainer__JXz0Zl",
  "NP": "narrowViewportWrapper__Uis-SQ",
  "cP": "titleSection__PUvpxr",
  "NG": "footerSection__kzv2bq",
  "NT": "actionsWrapper__rTb725",
  "vj": "editsSection__3L_O_u",
  "Wi": "badgesSection__IjiaLx",
  "lz": "badgeGroup__ZvfmMk",
  "p3": "actionsSection__QKxX29",
  "aD": "pullRequestAvatar__srbMuQ",
};

module.exports = exports;
